const hexToDecimal = (color) => parseInt(`0x${color}`, 16) || 0;
export const convertHexToRGB = (hex) => {
    let r = '0';
    let g = '0';
    let b = '0';
    if (hex.length === 4) {
        r = `${hex[1]}${hex[1]}`;
        g = `${hex[2]}${hex[2]}`;
        b = `${hex[3]}${hex[3]}`;
    }
    else if (hex.length === 7) {
        r = `${hex[1]}${hex[2]}`;
        g = `${hex[3]}${hex[4]}`;
        b = `${hex[5]}${hex[6]}`;
    }
    return [hexToDecimal(r), hexToDecimal(g), hexToDecimal(b)];
};
export const hexToRGBA = (hex, alpha = '1') => {
    let a = alpha;
    let h = hex;
    if (/^#\w{8}$/.test(hex)) {
        h = hex.slice(0, 7);
        a = (hexToDecimal(hex.slice(-2)) / 255).toFixed(2);
    }
    return `rgba(${convertHexToRGB(h).join(', ')}, ${a})`;
};
export const hexToRGB = (hex) => `rgb(${convertHexToRGB(hex).join(', ')})`;
//# sourceMappingURL=hex-to-rgba.js.map